import { gql } from '@apollo/client'

export const fundAdvisors = gql`
  query FundAdvisors($fundId: Int!) {
    fundAdvisors(fundId: $fundId) {
      advisorId
      email
      firstName
      lastName
      isOrganization
      corporateName
      rbacUserRoleId
      roleName
      permissions {
        menuGivingActivity
        menuInvestmentActivity
        menuContribute
        menuDocuments
        menuGrants
      }
      createdAt
    }
  }
`

export const userAdvisors = gql`
  query UserAdvisors($userId: Int!) {
    userAdvisors(userId: $userId) {
      advisorId
      email
      firstName
      lastName
      isOrganization
      corporateName
      fundId
      fundName
      createdAt
    }
  }
`
